module.exports = __webpack_public_path__ + "img/draganddrop-explanation-fr.ffa2ce95.png";